import { api } from "boot/axios";

export const getGenerator = async ({commit}, form) => {
  try {
    const resp = await api.post('/sunat/generator/filter/', {...form, comprobant: 'B'})
    commit('setTableGenerator', {data: resp.data, date: form})
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(error)
  }
}

// create
export const createGenerator = async ({commit}, form) => {
  try {
    const resp = await api.post('/sunat/generator/', form)
    commit('pushTableGenerator', resp.data.generator)
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(error)
  }
}
